
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.25 23.998a.755.755 0 01-.26-.047l-.022-.008a.732.732 0 01-.249-.165l-4.499-4.5c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53a.744.744 0 011.06 0l3.22 3.22V.748a.75.75 0 011.5 0v20.689l3.22-3.22a.744.744 0 011.06 0 .749.749 0 010 1.06l-4.5 4.5a.763.763 0 01-.246.164l-.027.01a.717.717 0 01-.257.047zM16.65 23.998a1.64 1.64 0 01-1.518-1.001 1.639 1.639 0 01-.014-1.262.729.729 0 01.075-.141l4.307-6.435v-.011c0-.041-.015-.077-.044-.106s-.065-.044-.106-.044h-3.6a.75.75 0 010-1.5h3.6a1.651 1.651 0 011.532 2.262.75.75 0 01-.074.14L16.5 22.337a.15.15 0 00.15.161h3.6a.75.75 0 010 1.5h-3.6zM15.75 10.5a.75.75 0 01-.75-.75V3c0-1.654 1.346-3 3-3s3 1.346 3 3v6.748a.75.75 0 01-1.5 0v-2.25h-3V9.75a.75.75 0 01-.75.75zm3.75-4.502V3c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5v2.998h3z"}})])
          )
        }
      }
    